import React, { useState } from 'react';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';
import { area, curveBasis } from 'd3';
import { connect } from 'unistore/react';

import Actions from '~/state/Actions';
import { weightedIncomeSelector, sizePerMemberSelector } from '~/state/Selectors';
import usePrevious from '~/hooks/usePrevious';

const AreaPath = styled(animated.path)``;

const Axis = styled.g`
  text {
    text-anchor: middle;
  }
`;

const AxisDomain = styled.line`
  stroke-width: 1px;
  stroke: ${(props) => props.theme.colors.greyblue};
`;

const AreaChart = ({
  xScale,
  yScale,
  data,
  width,
  height,
  dataKey,
  setTooltipVisibility,
  setTooltipKey,
  id,
  aboveColor,
  aboveHoverColor,
  belowColor,
  belowHoverColor,
  sizePerMember,
}) => {
  const [isHovered, setHovered] = useState(false);

  const x0 = xScale(0);

  const areaGenerator = area()
    .x0(() => x0)
    .x1((d) => xScale(+d[dataKey]))
    .y((d) => yScale(d.size))
    .curve(curveBasis);

  const prevLength = usePrevious(data.length);
  const reset = prevLength !== data.length;

  const pathData = useSpring({ d: areaGenerator(data), reset });

  const handleMouseEnter = () => {
    setTooltipVisibility(true);
    setTooltipKey(dataKey);
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setTooltipVisibility(false);
    setHovered(false);
  };

  const clipPathBelowId = `${id}__clipPathBelow`;
  const clipPathAboveId = `${id}__clipPathAbove`;
  const pathId = `${id}__path`;

  const colorAbove = isHovered ? aboveHoverColor : aboveColor;
  const colorBelow = isHovered ? belowHoverColor : belowColor;

  return (
    <g>
      <clipPath id={clipPathAboveId}>
        <rect x={0} y={0} height={yScale(sizePerMember)} width={width} />
      </clipPath>
      <clipPath id={clipPathBelowId}>
        <rect
          x={0}
          y={yScale(sizePerMember)}
          height={height - yScale(sizePerMember)}
          width={width}
        />
      </clipPath>
      <AreaPath
        id={pathId}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        d={pathData.d}
      />
      <use
        style={{ pointerEvents: 'none' }}
        stroke={colorAbove}
        fill={colorAbove}
        clipPath={`url(#${clipPathAboveId})`}
        xlinkHref={`#${pathId}`}
      />
      <use
        style={{ pointerEvents: 'none' }}
        stroke={colorBelow}
        fill={colorBelow}
        clipPath={`url(#${clipPathBelowId})`}
        xlinkHref={`#${pathId}`}
      />
      <Axis>
        <AxisDomain x1={0} x2={width} y1={height} y2={height} />
        {/* ticks.map(t => <ChartLabel key={`Tick__${t}`} x={xScale(t)} y={height + 10}>{t}</ChartLabel>) */}
      </Axis>
      <Axis>
        <AxisDomain x1={x0} x2={x0} y1={0} y2={height} />
      </Axis>
    </g>
  );
};

export default connect(
  (state) => ({
    weightedIncome: weightedIncomeSelector(state),
    sizePerMember: sizePerMemberSelector(state),
  }),
  Actions
)(AreaChart);
